module.exports = __webpack_public_path__ + "img/BNB.9faf561e.png";